<template>

  <button class="h-full border-l border-gray-400 rounded-r-sm"
          :tabindex="!reference ? '0' : '-1'"
          :disabled="disabled"
          @click.stop.prevent="uomClicked">
    <div class="leading-none relative">
      <div class="block">
        <div  v-if="uom.name == 'time'"
              class="relative cursor-pointer">
          <div  class="relative rounded-r w-8 h-full p-1 bg-white hover:bg-gray-200"
                :class="{ 'cursor-default bg-gray-200' : (reference || disabled) && !editable }">
            <IconClock></IconClock>

            <div class="absolute px-px left-0 bottom-0 rounded-full bg-inherit">
              <div>{{ uomSymbol }}</div>
            </div>
          </div>
        </div>
        <div  v-if="uom.name == 'materials'"
              class="rounded-r w-8 h-full p-1 bg-white hover:bg-gray-200 cursor-pointer"
              :class="{ 'cursor-default bg-gray-200' : (reference || disabled) && !editable }">
          <IconTag></IconTag>
        </div>
      </div>
      <div  class="origin-top-right absolute z-10 right-0 lg:left-0 mt-2 rounded-md shadow-lg"
            :class="{ hidden: !showMenu }">
        <RowUomMenu @setTime="setTime"
                    @setMaterials="setMaterials"></RowUomMenu>
      </div>
    </div>
  </button>

</template>

<script>
import RowUomMenu from '@/components/row/uom/RowUomMenu'
import IconTag from '@/components/icons/IconTag'
import IconClock from '@/components/icons/IconClock'

export default {
  name: 'RowUom',
  components: {
    RowUomMenu,
    IconTag,
    IconClock
  },
  props: {
    value: Object,
    reference: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMenu: false
    };
  },
  computed: {
    uom: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    },
    uomSymbol() {
      if (this.uom && this.uom.unit) {
        return this.uom.unit.charAt(0).toUpperCase();
      } else {
        return '';
      }
    }
  },
  methods: {
    uomClicked(){
      if(this.reference && !this.editable){
        this.$emit('edit-reference')
      }else{
        this.toggleMenu()
      }
    },
    setMaterials() {
      this.uom.name = 'materials';
      this.uom.unit = '';
      this.hideMenu();
    },
    setTime(unit) {
      this.uom.name = 'time';
      this.uom.unit = unit;
      this.hideMenu();
    },
    hideMenu() {
      console.log('hideMenu')
      this.showMenu = false;
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    }
  },
  created() {
    //window.addEventListener('click', this.hideMenu, true);
  },
  destroyed() {
    //window.removeEventListener('click', this.hideMenu);
  }
};
</script>
